/* ChicChac — wishlist page + header entry point (founder change-set v2)
   "Wishlist page view and manage move to cart functionality"

   Reads the same localStorage key (`cc_wishlist`, an array of product handles)
   that cc-cards.js and cc-product.js write, hydrates each handle from
   /products/<handle>.js, and renders a manageable grid: remove, or move to
   cart (adds the variant then drops it from the wishlist).

   Mounts on any page containing #cc-wishlist-root — supplied either by
   sections/cc-wishlist.liquid (templates/page.wishlist.json) or by pasting
   `<div id="cc-wishlist-root"></div>` into a normal page's content.

   Also injects the header wishlist icon + count bubble on every page.
   No external dependencies. */
(function () {
  'use strict';
  var WKEY = 'cc_wishlist';

  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function saveWl(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cc:wishlist', { bubbles: true })); } catch (e) {}
  }
  function removeHandle(h) {
    var a = wl(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); saveWl(a); }
  }

  /* Founder change-set v3: "Change heart icon in the wishlist button". The old
     glyph was a solid filled blob that read as a smudge at 18px. This one is a
     drawn outline that only fills once the piece is actually saved, so the
     saved/not-saved state is legible instead of colour-only. */
  var HEART = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3 4.7 13a4.7 4.7 0 0 1 6.6-6.6l.7.7.7-.7A4.7 4.7 0 1 1 19.3 13z"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var X = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';

  var inr = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(paise) { return '₹' + inr.format((paise || 0) / 100); }

  function toast(msg) {
    var t = document.getElementById('cc-toast');
    if (!t) { t = document.createElement('div'); t.id = 'cc-toast'; t.className = 'cc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  function refreshCartBubble() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
          el.textContent = c.item_count; el.classList.remove('hidden');
        });
        document.querySelectorAll('.cart-bubble').forEach(function (b) {
          if (c.item_count > 0) b.classList.remove('visually-hidden');
        });
        return c;
      });
  }

  /* Re-render Horizon's cart drawer with the freshly-added line, same approach
     as cc-cards.js — a raw /cart/add.js leaves the drawer stale. */
  function updateCartDrawer(sections) {
    if (!sections) return;
    var id = 'cart-drawer-section';
    var html = sections[id];
    var target = document.getElementById('shopify-section-' + id);
    if (!html || !target) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var inner = tmp.querySelector('#shopify-section-' + id);
    target.innerHTML = inner ? inner.innerHTML : html;
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) { updateCartDrawer(res && res.sections); return refreshCartBubble(); });
  }

  /* ---------------- header icon ---------------- */

  function headerCount() {
    var n = wl().length;
    document.querySelectorAll('.cc-wish-link__count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    /* Fill the outline heart once anything is saved, so the header reflects
       state at a glance rather than only through the count bubble. */
    document.querySelectorAll('.cc-wish-link').forEach(function (el) {
      el.classList.toggle('is-active', n > 0);
    });
  }

  function injectHeaderIcon() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.cc-wish-link')) return;
    var a = document.createElement('a');
    a.className = 'cc-wish-link header-actions__action';
    a.href = '/pages/wishlist';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = HEART + '<span class="cc-wish-link__count is-empty">0</span>';
    /* The /pages/wishlist page is a Shopify Page object that has to be created in
       the admin; until it exists that URL 404s. So the icon opens a drawer
       instead, which needs no page and works everywhere. Once the page exists,
       set data-cc-wishlist-page="1" on <body> (or just create the page and flip
       HAS_PAGE below) and the icon becomes a normal link to the full page. */
    a.addEventListener('click', function (e) {
      if (hasWishlistPage()) return;   // let the browser follow the link
      e.preventDefault();
      openDrawer(a);
    });
    /* Sit just before the cart so the order reads search · account · wishlist · cart.
       Horizon wraps <cart-icon> in a <button>, so walk up to whichever ancestor
       is the direct child of <header-actions> before inserting. */
    var cart = actions.querySelector('cart-icon');
    var anchor = cart;
    while (anchor && anchor.parentNode !== actions) anchor = anchor.parentNode;
    if (anchor) actions.insertBefore(a, anchor);
    else actions.appendChild(a);
    headerCount();
  }

  function hasWishlistPage() {
    return document.body.hasAttribute('data-cc-wishlist-page');
  }

  /* ---------------- drawer ---------------- */

  var drawer = null;
  /* A2-002: the element focus should return to once the drawer closes —
     whatever was focused when openDrawer() was called (normally the header
     wishlist icon, but passed explicitly rather than assumed). */
  var lastTrigger = null;

  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'cc-wishdrawer';
    drawer.setAttribute('hidden', '');
    drawer.innerHTML =
      '<div class="cc-wishdrawer__scrim" data-close></div>' +
      '<aside class="cc-wishdrawer__panel" role="dialog" aria-modal="true" aria-label="Wishlist">' +
        '<header class="cc-wishdrawer__head">' +
          '<h2>Your wishlist</h2>' +
          '<button type="button" class="cc-wishdrawer__close" aria-label="Close wishlist" data-close>' + X + '</button>' +
        '</header>' +
        '<div class="cc-wishdrawer__body"></div>' +
      '</aside>';
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) closeDrawer();
    });
    document.body.appendChild(drawer);
    return drawer;
  }

  var FOCUSABLE_SEL =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* A2-002: the drawer already focused its close button on open, but there
     was no trap — the second Tab press walked straight out into the (still
     visible, still interactive) page behind it. This is a plain manual trap
     rather than Horizon's @theme/focus trapFocus() import, because this file
     is a classic script with no build step to pull that module in. Re-reads
     the panel's focusable elements on every Tab press rather than caching
     them once, since remove/move-to-cart buttons change the panel's content
     while it's open. */
  function trapTab(e) {
    if (e.key !== 'Tab' || !drawer) return;
    var panel = drawer.querySelector('.cc-wishdrawer__panel');
    if (!panel) return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE_SEL));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !panel.contains(active)) {
        e.preventDefault();
        last.focus();
      }
    } else if (active === last || !panel.contains(active)) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    trapTab(e);
  }

  function openDrawer(trigger) {
    lastTrigger = trigger || document.activeElement;
    var d = buildDrawer();
    d.removeAttribute('hidden');
    /* next frame so the transition runs from the hidden state */
    requestAnimationFrame(function () { d.classList.add('is-on'); });
    document.addEventListener('keydown', onKeydown);
    renderInto(d.querySelector('.cc-wishdrawer__body'));
    var close = d.querySelector('.cc-wishdrawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-on');
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () { if (drawer && !drawer.classList.contains('is-on')) drawer.setAttribute('hidden', ''); }, 260);
    /* A2-002: return focus to whatever opened the drawer — without this the
       browser drops it onto <body> once the trigger's surroundings settle. */
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  /* ---------------- wishlist page ---------------- */

  function card(p, handle) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    var img = p.featured_image || (p.images && p.images[0]);
    var el = document.createElement('div');
    el.className = 'cc-wish-card';
    el.dataset.handle = handle;

    var onSale = !!(v && v.compare_at_price > v.price);
    var soldOut = !(v && v.available);

    /* Static skeleton only — every value that comes from the product payload is
       written below with textContent / setAttribute, never interpolated into
       markup, so a title containing quotes or angle brackets can't break out. */
    el.innerHTML =
      '<a class="cc-wish-card__media">' +
        (img ? '<img alt="" loading="lazy" decoding="async">' : '<span class="cc-wish-card__ph"></span>') +
      '</a>' +
      '<button type="button" class="cc-wish-card__remove" aria-label="Remove from wishlist">' + X + '</button>' +
      '<div class="cc-wish-card__body">' +
        '<a class="cc-wish-card__title"></a>' +
        '<div class="cc-wish-card__price"><span class="cc-wish-card__now"></span>' +
          (onSale ? '<s class="cc-wish-card__was"></s>' : '') +
        '</div>' +
        (onSale ? '<span class="cc-wish-card__off"></span>' : '') +
        '<button type="button" class="cc-wish-card__move"' + (soldOut ? ' disabled' : '') + '>' +
          BAG + '<span></span>' +
        '</button>' +
      '</div>';

    var url = '/products/' + encodeURIComponent(handle);
    el.querySelector('.cc-wish-card__media').setAttribute('href', url);
    var imgEl = el.querySelector('.cc-wish-card__media img');
    if (imgEl) imgEl.setAttribute('src', img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=500');

    var titleEl = el.querySelector('.cc-wish-card__title');
    titleEl.setAttribute('href', url);
    titleEl.textContent = p.title;

    el.querySelector('.cc-wish-card__now').textContent = money(v ? v.price : 0);
    if (onSale) {
      el.querySelector('.cc-wish-card__was').textContent = money(v.compare_at_price);
      el.querySelector('.cc-wish-card__off').textContent =
        Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF';
    }
    el.querySelector('.cc-wish-card__move span').textContent = soldOut ? 'Sold out' : 'Move to cart';

    el.querySelector('.cc-wish-card__remove').addEventListener('click', function () {
      removeHandle(handle);
      el.classList.add('is-going');
      setTimeout(function () { el.remove(); render(); }, 180);
      toast('Removed from wishlist');
    });

    var move = el.querySelector('.cc-wish-card__move');
    if (!soldOut) {
      move.addEventListener('click', function () {
        move.disabled = true; move.classList.add('is-loading');
        addToCart(v.id)
          .then(function () {
            removeHandle(handle);
            el.classList.add('is-going');
            setTimeout(function () { el.remove(); render(); }, 180);
            toast('Moved to cart');
          })
          .catch(function () {
            move.disabled = false; move.classList.remove('is-loading');
            toast('Could not add to cart');
          });
      });
    }
    return el;
  }

  /* Renders the wishlist into any container — the page root on
     /pages/wishlist, or the drawer body everywhere else. */
  function renderInto(container) {
    if (!container) return;
    var handles = wl();
    headerCount();

    if (!handles.length) {
      container.innerHTML =
        '<div class="cc-wish-empty">' +
          '<span class="cc-wish-empty__icon">' + HEART + '</span>' +
          '<h2>Your wishlist is empty</h2>' +
          '<p>Tap the heart on any piece to save it here for later.</p>' +
          '<a class="cc-ghost" href="/collections/all">Start browsing</a>' +
        '</div>';
      return;
    }

    container.innerHTML = '<div class="cc-wish-grid" aria-busy="true"></div>';
    var grid = container.firstChild;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return { handle: h, product: p }; })
        .catch(function () { return { handle: h, product: null }; });
    })).then(function (results) {
      /* Drop handles whose product is gone (unpublished/deleted) so the list
         doesn't accumulate dead entries. */
      var alive = results.filter(function (r) { return r.product; });
      if (alive.length !== results.length) {
        saveWl(alive.map(function (r) { return r.handle; }));
      }
      if (!alive.length) { renderInto(container); return; }
      alive.forEach(function (r) { grid.appendChild(card(r.product, r.handle)); });
      grid.removeAttribute('aria-busy');
      headerCount();
    });
  }

  /* Re-render whichever surface is currently showing the list. */
  function render() {
    var page = document.getElementById('cc-wishlist-root');
    if (page) renderInto(page);
    if (drawer && drawer.classList.contains('is-on')) {
      renderInto(drawer.querySelector('.cc-wishdrawer__body'));
    }
  }

  function init() {
    injectHeaderIcon();
    var page = document.getElementById('cc-wishlist-root');
    if (page) {
      /* we're on the real wishlist page — make the header icon a plain link */
      document.body.setAttribute('data-cc-wishlist-page', '');
      renderInto(page);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('cc:wishlist', headerCount);
  /* another tab changed the wishlist */
  window.addEventListener('storage', function (e) {
    if (e.key !== WKEY) return;
    headerCount();
    render();
  });
})();
